export const mainCls = 'csa-login-button';

export default {
  [mainCls]: {
    margin: '0 auto',
    width: 208,
  },
};
